const Connect = require("react-redux").connect;
const Pricing = require("../components/Pricing");
const CheckoutActions = require("actions/checkout");
const DialogActions = require("actions/dialog");

const internals = {};

internals.connect = Connect(
    state => ({
        paymentOptions: state.checkout.paymentOptions,
        isAuthenticated: state.auth.isAuthenticated
    }),
    {
        onAddCreditsClick: () => {
            return dispatch => {
                dispatch(CheckoutActions.startTransaction("credits"));
                dispatch(DialogActions.openTransactionDialog());
            };
        },
        onSeeWhatsIncluded: () => {
            return dispatch => {
                dispatch(DialogActions.openWhatsIncludedDialog());
            };
        }
    }
);

module.exports = internals.connect(Pricing);



// WEBPACK FOOTER //
// ./src/routes/pricing/containers/Pricing.js